import React from "react";
import { ToastStack } from "../../molecules/ToastStack";
import type { ToastViewportProps } from "./ToastViewport.types";
import { useToastViewportInternalState } from "./useToastViewportInternalState";

/** The app's one toast stack. Mounted once, in App, inside the router; anything calls `notify()`. */
export const ToastViewport: React.FC<ToastViewportProps> = ({ className }) => {
  const stack = useToastViewportInternalState();
  return <ToastStack {...stack} className={className} />;
};

export default ToastViewport;
